import {
    BasicController, BasicModel, BasicStandardOkDialogProperties, EnvGlobalsHandler,
    TextValide
} from "@goodgamestudios/core";
import {Poker2SoundController} from "../../../controller/Poker2SoundController";
import {SFConstants} from "../../../constants/SFConstants";
import {Poker2Panel} from "../Poker2Panel";
import {Poker2LayoutManager} from "../../Poker2LayoutManager";
import DisplayObject = createjs.DisplayObject;
import MouseEvent = createjs.MouseEvent;

import MovieClip = createjs.MovieClip;
import TextField = createjs.TextField;
import FocusEvent = createjs.FocusEvent;
import {Poker2WarningDialog} from "../../dialogs/Poker2WarningDialog";
import {Poker2Model} from "../../../model/Poker2Model";

export class Poker2CheatsPanel extends Poker2Panel {
    public static NAME: string = "Poker2CheatsPanel";

    public static IS_CHEATING: boolean;

    private static OFFSET_X: number = 80;
    private static OFFSET_Y: number = 55;

    private static DEFAULT_TEXT: string = "Add cheat...";

    private btnApplyCheat: MovieClip;
    private inputCheat: TextField;

    constructor(disp: DisplayObject) {
        CONSTRUCTOR_HACK;
        super(disp);
    }

    protected init(): void {
        super.init();

        this.btnApplyCheat = this.cheatPanel.btn_apply_cheat;
        this.inputCheat = this.cheatPanel.inputCheat;

        this.fillDefaultText();

        this.btnApplyCheat.addEventListener(MouseEvent.CLICK, this.bindFunction(this.onApplyCheatClick));
        this.inputCheat.addEventListener(FocusEvent.FOCUS_IN, this.bindFunction(this.onFocusIn));
        this.inputCheat.addEventListener(FocusEvent.FOCUS_OUT, this.bindFunction(this.onFocusOut));
    }

    public show(): void {
        super.show();

        this.fillDefaultText();
    }

    public destroy(): void {
        this.btnApplyCheat.removeEventListener(MouseEvent.CLICK, this.bindFunction(this.onApplyCheatClick));
        this.inputCheat.removeEventListener(FocusEvent.FOCUS_IN, this.bindFunction(this.onFocusIn));
        this.inputCheat.removeEventListener(FocusEvent.FOCUS_OUT, this.bindFunction(this.onFocusOut));

        super.destroy();
    }

    public updatePosition(): void {
        if (this.cheatPanel && this.cheatPanel.stage) {
            this.cheatPanel.scaleX = this.cheatPanel.scaleY = this.layoutManager.scaleFactor;
            this.cheatPanel.x = (this.cheatPanel.stage.stageWidth / 2) + (Poker2CheatsPanel.OFFSET_X * this.layoutManager.scaleFactor);
            this.cheatPanel.y = Poker2CheatsPanel.OFFSET_Y * this.layoutManager.scaleFactor;
        }
    }

    private onApplyCheatClick(event: MouseEvent): void {
        if (this.tutorialController.isActive) // can't cheat during tutorial ;)
            return;

        if (event.currentTarget == this.btnApplyCheat) {
            BasicController.getInstance().soundController.playSoundEffectByName(Poker2SoundController.SND_CLICK);
            this.onSendMsg();
        }
    }

    private onSendMsg(): void {
        Poker2CheatsPanel.IS_CHEATING = false;

        if (this.inputCheat.text == "/clientversion") { // TODO - probably we can extract the client cheats to commands... later
            let message = "Client Version:\n" + EnvGlobalsHandler.globals.versionText;
            console.log(message);
            this.layoutManager.showDialog("Poker2WarningDialog", new BasicStandardOkDialogProperties(Poker2Model.languageData.getTextById("generic_alert_information"), message));

            this.fillDefaultText();
            return;
        }

        if (this.inputCheat.text == "/hideCheats") {
            this.hide(); // hiding the panel... coz why not ;)
            return;
        }

        var chatMsg: string = TextValide.getValideSmartFoxJSONTextMessage(this.inputCheat.text);

        if (chatMsg.length > 0) {

            // bypass the not on table error from server
            if (this.layoutManager.currentState != 10) { // we are in the lobby
                Poker2CheatsPanel.IS_CHEATING = true;
                BasicModel.smartfoxClient.sendMessage("tjn", [JSON.stringify({id: 0, ts: 2})]);
            }

            // send cheat to server
            BasicModel.smartfoxClient.sendMessage("tch", [JSON.stringify({text: chatMsg})]);

            // reset to lobby if C2S_TABLE_JOIN has been sent, otherwise bugs might occur
            if (this.layoutManager.currentState != 10) {
                BasicModel.smartfoxClient.sendMessage("tle", []);
            }
        }

        this.fillDefaultText();
    }

    private onFocusIn(event: FocusEvent): void {
        if (this.inputCheat.text.length == 0 || this.inputCheat.text == Poker2CheatsPanel.DEFAULT_TEXT) {
            this.inputCheat.text = "";
        }
    }

    protected onFocusOut(event: FocusEvent): void {
        if (this.inputCheat.text == "") {
            this.fillDefaultText();
        }
    }

    private fillDefaultText(): void {
        this.inputCheat.text = Poker2CheatsPanel.DEFAULT_TEXT;
    }

    private get cheatPanel(): Library.PokerCheatsPanel.PokerCheatsPanel {
        return this.disp as Library.PokerCheatsPanel.PokerCheatsPanel;
    }
}
